import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {KsForm} from ".";

type PreviewProps = {
    test: Test
}

export class KsRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <KsForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}